declare namespace $ {

	type $mol_view__sub_giper_balls_game_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_giper_balls_game_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_giper_balls_game_3 = $mol_type_enforce<
		ReturnType< $giper_balls_game['restart'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_balls_game_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_chip__sub_giper_balls_game_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chip['sub'] >
	>
	type $mol_view__sub_giper_balls_game_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $giper_balls_ball__kind_giper_balls_game_7 = $mol_type_enforce<
		ReturnType< $giper_balls_game['ball_kind'] >
		,
		ReturnType< $giper_balls_ball['kind'] >
	>
	type $giper_balls_ball__mood_giper_balls_game_8 = $mol_type_enforce<
		ReturnType< $giper_balls_game['ball_mood'] >
		,
		ReturnType< $giper_balls_ball['mood'] >
	>
	type $giper_balls_ball__active_giper_balls_game_9 = $mol_type_enforce<
		ReturnType< $giper_balls_game['cell_active'] >
		,
		ReturnType< $giper_balls_ball['active'] >
	>
	type $giper_balls_ball__colors_giper_balls_game_10 = $mol_type_enforce<
		ReturnType< $giper_balls_game['colors'] >
		,
		ReturnType< $giper_balls_ball['colors'] >
	>
	type $giper_balls_ball__focus_giper_balls_game_11 = $mol_type_enforce<
		ReturnType< $giper_balls_game['ball_focus'] >
		,
		ReturnType< $giper_balls_ball['focus'] >
	>
	type $mol_stack__event_giper_balls_game_12 = $mol_type_enforce<
		({ 
			touchstart( next?: ReturnType< $giper_balls_game['select'] > ): ReturnType< $giper_balls_game['select'] >,
			pointerdown( next?: ReturnType< $giper_balls_game['ball_grab'] > ): ReturnType< $giper_balls_game['ball_grab'] >,
			pointerenter( next?: ReturnType< $giper_balls_game['ball_move'] > ): ReturnType< $giper_balls_game['ball_move'] >,
			pointerup( next?: ReturnType< $giper_balls_game['ball_drop'] > ): ReturnType< $giper_balls_game['ball_drop'] >,
		}) 
		,
		ReturnType< $mol_stack['event'] >
	>
	type $mol_stack__sub_giper_balls_game_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_stack['sub'] >
	>
	type $mol_view__sub_giper_balls_game_14 = $mol_type_enforce<
		ReturnType< $giper_balls_game['cells'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_giper_balls_game_15 = $mol_type_enforce<
		ReturnType< $giper_balls_game['rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $giper_balls_game extends $mol_page {
		select( next?: any ): any
		Share( ): $mol_button_share
		Caption( ): $mol_view
		restart( next?: any ): any
		Restart_icon( ): $mol_icon_autorenew
		Restart( ): $mol_button_minor
		score_text( ): string
		Score( id: any): $mol_chip
		Score_pick( ): ReturnType< $giper_balls_game['Score'] >
		Main( ): $mol_view
		ball_grab( id: any, next?: any ): any
		ball_move( id: any, next?: any ): any
		ball_drop( id: any, next?: any ): any
		ball_kind( id: any, next?: number ): number
		ball_mood( id: any): string
		cell_active( id: any, next?: boolean ): boolean
		ball_focus( id: any): boolean
		Ball( id: any): $giper_balls_ball
		Cell( id: any): $mol_stack
		cells( id: any): readonly(any)[]
		Row( id: any): $mol_view
		rows( ): readonly(any)[]
		Board( ): $mol_view
		size( ): number
		colors( ): readonly(any)[]
		mood_smiles( ): readonly(any)[]
		lives( next?: number ): number
		spend_life( next?: boolean ): boolean
		active_cell( next?: readonly(number)[] ): readonly(number)[]
		score( next?: number ): number
		event( ): ({ 
			selectionchange( next?: ReturnType< $giper_balls_game['select'] > ): ReturnType< $giper_balls_game['select'] >,
		})  & ReturnType< $mol_page['event'] >
		head( ): readonly(any)[]
		body_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=game.view.tree.d.ts.map